import styled from 'styled-components';
import { palette } from '@dev/ee-components';

type StyledProps = {
    marginTop?: number;
    marginBottom?: number;
};

export const Divider = styled.div<StyledProps>`
    height: 1px;
    width: 100%;
    background-color: ${palette.gray[3]};
    margin-top: ${({ marginTop }): number => (marginTop ? marginTop : 0)}px;
    margin-bottom: ${({ marginBottom }): number => (marginBottom ? marginBottom : 0)}px;
`;